// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-carousel_layout__Yg8fT","sliderButton":"speaker-carousel_sliderButton__tjRNg","prev":"speaker-carousel_prev__dmE6w","next":"speaker-carousel_next__iACD_"};